/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BannerResponse,
  ConfigureBannerRequest,
  ProblemDetails,
  ValidationProblemDetails,
} from '../models/index';
import {
    BannerResponseFromJSON,
    BannerResponseToJSON,
    ConfigureBannerRequestFromJSON,
    ConfigureBannerRequestToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface ConfigureBannerOperationRequest {
    configureBannerRequest: ConfigureBannerRequest;
}

/**
 * BannersApi - interface
 * 
 * @export
 * @interface BannersApiInterface
 */
export interface BannersApiInterface {
    /**
     * 
     * @param {ConfigureBannerRequest} configureBannerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApiInterface
     */
    configureBannerRaw(requestParameters: ConfigureBannerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BannerResponse>>;

    /**
     */
    configureBanner(requestParameters: ConfigureBannerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BannerResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApiInterface
     */
    deactivateBannerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deactivateBanner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannersApiInterface
     */
    getActiveBannerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BannerResponse>>;

    /**
     */
    getActiveBanner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BannerResponse | null | undefined >;

}

/**
 * 
 */
export class BannersApi extends runtime.BaseAPI implements BannersApiInterface {

    /**
     */
    async configureBannerRaw(requestParameters: ConfigureBannerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BannerResponse>> {
        if (requestParameters['configureBannerRequest'] == null) {
            throw new runtime.RequiredError(
                'configureBannerRequest',
                'Required parameter "configureBannerRequest" was null or undefined when calling configureBanner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/banners`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConfigureBannerRequestToJSON(requestParameters['configureBannerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BannerResponseFromJSON(jsonValue));
    }

    /**
     */
    async configureBanner(requestParameters: ConfigureBannerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BannerResponse> {
        const response = await this.configureBannerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deactivateBannerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/banners`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deactivateBanner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deactivateBannerRaw(initOverrides);
    }

    /**
     */
    async getActiveBannerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BannerResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/banners/active`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BannerResponseFromJSON(jsonValue));
    }

    /**
     */
    async getActiveBanner(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BannerResponse | null | undefined > {
        const response = await this.getActiveBannerRaw(initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

}
